import React from 'react'
import { AuthorizeSkinProps } from '../types'
import AuthorizeSkin from './authorize-skin'
import useAuthorizeSkinController from './hooks/use-authorize-skin-controller'

type Props = AuthorizeSkinProps

/**
 * AuthorizeSkinContainer — 将授权皮肤本地协议确认交互与旧授权容器回调连接起来。
 * @returns {React.ReactElement} 可直接挂载的授权皮肤
 */
const AuthorizeSkinContainer: React.FC<Props> = React.memo(props => {
  const controller = useAuthorizeSkinController({
    model: props.model,
    onBack: props.onBack,
    onConfirmAgreement: props.onConfirmAgreement,
    onSubmit: props.onSubmit,
  })

  return <AuthorizeSkin {...props} controller={controller} />
})

AuthorizeSkinContainer.displayName = 'AuthorizeSkinContainer'

export default AuthorizeSkinContainer
